module.exports = __webpack_public_path__ + "static/sport/title.67d1396.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/title.png
// module id = ve7A
// module chunks = 0